
import { Base } from '../base-component';

import './contact-tile3-country-indiv-stack.component.scss';

export class ContactTile3CountryIndivStack extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){}

	bindEvents() {}

}


// WEBPACK FOOTER //
// ./components/contact-tile3-country-indiv-stack/contact-tile3-country-indiv-stack.component.ts